import axios from "axios";
import routes from "../app/routes";

const prepareFormDataForSend = (values) => {
  let formData = {
    title: values.title,
    topic_category_id: values.topicCategoryId,
  };
  return formData;
};

export const topicActions = {
  loadTopics: (dispatch) => {
    axios.get(routes.api.topics.index).then((resp) => {
      dispatch({
        type: "loadTopics",
        topics: resp.data.data,
      });
    });
  },
  saveTopic: (dispatch, values, successCallback, errorCallback) => {
    axios
      .post(routes.api.topics.create, {
        ...prepareFormDataForSend(values),
      })
      .then((resp) => {
        successCallback(resp.data.data);
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },
  deleteTopic: (dispatch, topicId) => {
    axios.delete(routes.api.topics.destroy(topicId)).then((resp) => {
      dispatch({
        type: "deleteTopic",
        topicId: topicId,
      });
    });
  },
  editTopic: (topicId) => {
    document.location.href = routes.api.topics.edit(topicId);
  },
  showCreateForm: (dispatch) => {
    dispatch({ type: "showModal" });
  },
  hideModal: (dispatch) => {
    dispatch({ type: "hideModal" });
  },
};
